'use client'

import { memo } from 'react'
import IconDefaultAmenity from '~/icons/ic_default_amenity'
import { Image } from '~/components/ui/image'

interface RoomAmenitiesProps {
  roomServices?: Array<{ icon?: string; serviceName: string }>
}

function RoomAmenities({ roomServices }: RoomAmenitiesProps) {
  return (
    <div className="flex gap-2">
      {roomServices?.slice(0, 3).map((service) => (
        <div
          key={service.serviceName}
          className="flex aspect-square h-6 w-6 items-center justify-center rounded-[4px] bg-[#F3F3F3] p-1"
        >
          {service.icon ? (
            <Image
              src={service.icon}
              alt={service.serviceName}
              fill
              aspectRatio={'1/1'}
              objectFit={'contain'}
              className="h-5 w-5 text-[#666]"
            />
          ) : (
            <IconDefaultAmenity className="h-5 w-5 text-[#666]" />
          )}
        </div>
      ))}
    </div>
  )
}

function arePropsEqual(prevProps: RoomAmenitiesProps, nextProps: RoomAmenitiesProps) {
  if (!prevProps.roomServices && !nextProps.roomServices) return true
  if (!prevProps.roomServices || !nextProps.roomServices) return false
  if (prevProps.roomServices.length !== nextProps.roomServices.length) return false
  return prevProps.roomServices.every((service, index) => {
    return (
      service.icon === nextProps.roomServices![index].icon &&
      service.serviceName === nextProps.roomServices![index].serviceName
    )
  })
}

export default memo(RoomAmenities, arePropsEqual)
